import { useEffect, useState } from 'react';

export const useCursorPosition = (offsetX: number, offsetY: number) => {
    const [{ pointerX, pointerY }, setXY] = useState({ pointerX: 0, pointerY: 0 });
    useEffect(() => {
        const callback = (event: MouseEvent) =>
            setXY({ pointerX: event.clientX - offsetX, pointerY: event.clientY - offsetY });
        document.addEventListener('mousemove', callback);

        return () => document.removeEventListener('mousemove', callback);
    }, [offsetX, offsetY]);

    return {
        pointerX: isFinite(pointerX) ? pointerX : 0,
        pointerY: isFinite(pointerY) ? pointerY : 0,
    };
};
